// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteLicenseUpsearchModel {
    static getAttributeTypeMap() {
        return SiteLicenseUpsearchModel.attributeTypeMap;
    }
}
SiteLicenseUpsearchModel.discriminator = undefined;
SiteLicenseUpsearchModel.additionalProperties = false;
SiteLicenseUpsearchModel.attributeTypeMap = [
    {
        "name": "siteLicenseId",
        "baseName": "siteLicenseId",
        "type": "number"
    },
    {
        "name": "licenseType",
        "baseName": "licenseType",
        "type": "SiteLicenseType"
    },
    {
        "name": "licenseNumber",
        "baseName": "licenseNumber",
        "type": "string"
    },
    {
        "name": "licenseStateCd",
        "baseName": "licenseStateCd",
        "type": "string"
    },
    {
        "name": "licenseExpirationDt",
        "baseName": "licenseExpirationDt",
        "type": "Date"
    },
];
//# sourceMappingURL=siteLicenseUpsearchModel.js.map